export const firstMetaPagination = {
	current_page: 1,
	next_page: null,
	prev_page: null,
	total_count: 1,
	total_pages: 1,
};
